import Link from "next/link";
import { Menu } from "antd";

import { userUrl } from "utils/route";

const UserNavs = ({ user, activeKey }: { user: any; activeKey: any }) => {
  let items = [
    {
      label: (
        <Link
          legacyBehavior
          href="/users/[id]"
          as={userUrl(user)}
        >
          <a className="menu-link-item">个人信息</a>
        </Link>
      ),
      key: "info",
    },
  ];
  const otherItems = [
    {
      label: (
        <Link
          legacyBehavior
          href="/users/[id]"
          as={userUrl(user)}
        >
          <a className="menu-link-item">全部帖子</a>
        </Link>
      ),
      key: "posts",
    },
    {
      label: (
        <Link
          legacyBehavior
          href="/users/[id]/replies"
          as={`${userUrl(user)}/replies`}
        >
          <a className="menu-link-item">TA的评论</a>
        </Link>
      ),
      key: "replies",
    },
  ];
  if (["posts", "replies"].includes(activeKey)) {
    items = otherItems;
  }

  return (
    <Menu
      items={items}
      selectedKeys={[activeKey]}
      mode="horizontal"
    />
  );
};
export default UserNavs;
